import whatsNew180 from "@docs/whats-new/v1.8.0.md?raw";
import whatsNew178 from "@docs/whats-new/v1.7.8.md?raw";
import whatsNew177 from "@docs/whats-new/v1.7.7.md?raw";
import whatsNew176 from "@docs/whats-new/v1.7.6.md?raw";
import whatsNew175 from "@docs/whats-new/v1.7.5.md?raw";
import whatsNew174 from "@docs/whats-new/v1.7.4.md?raw";
import whatsNew173 from "@docs/whats-new/v1.7.3.md?raw";
import whatsNew172 from "@docs/whats-new/v1.7.2.md?raw";
import whatsNew171 from "@docs/whats-new/v1.7.1.md?raw";
import whatsNew170 from "@docs/whats-new/v1.7.0.md?raw";
import whatsNew168 from "@docs/whats-new/v1.6.8.md?raw";
import whatsNew167 from "@docs/whats-new/v1.6.7.md?raw";
import whatsNew166 from "@docs/whats-new/v1.6.6.md?raw";
import whatsNew165 from "@docs/whats-new/v1.6.5.md?raw";
import whatsNew164 from "@docs/whats-new/v1.6.4.md?raw";
import whatsNew163 from "@docs/whats-new/v1.6.3.md?raw";
import whatsNew162 from "@docs/whats-new/v1.6.2.md?raw";
import whatsNew161 from "@docs/whats-new/v1.6.1.md?raw";
import whatsNew160 from "@docs/whats-new/v1.6.0.md?raw";
import whatsNew150 from "@docs/whats-new/v1.5.0.md?raw";
import whatsNew148 from "@docs/whats-new/v1.4.8.md?raw";
import whatsNew147 from "@docs/whats-new/v1.4.7.md?raw";
import whatsNew146 from "@docs/whats-new/v1.4.6.md?raw";
import whatsNew145 from "@docs/whats-new/v1.4.5.md?raw";
import whatsNew144 from "@docs/whats-new/v1.4.4.md?raw";
import whatsNew143 from "@docs/whats-new/v1.4.3.md?raw";
import whatsNew142 from "@docs/whats-new/v1.4.2.md?raw";
import whatsNew141 from "@docs/whats-new/v1.4.1.md?raw";
import whatsNew140 from "@docs/whats-new/v1.4.0.md?raw";
import whatsNew131 from "@docs/whats-new/v1.3.1.md?raw";
import whatsNew130 from "@docs/whats-new/v1.3.0.md?raw";
import whatsNew121 from "@docs/whats-new/v1.2.1.md?raw";
import whatsNew120 from "@docs/whats-new/v1.2.0.md?raw";
import whatsNew110 from "@docs/whats-new/v1.1.0.md?raw";
import whatsNew101 from "@docs/whats-new/v1.0.1.md?raw";
import whatsNew100 from "@docs/whats-new/v1.0.0.md?raw";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MarkdownRenderer } from "@/components/common/markdown-renderer";
import { usePageTitle } from "@/hooks/use-page-title";
import { APP_VERSION } from "@/lib/constants";

// Release history - newest first
const releases = [
  {
    version: "1.8.0",
    title: "Dashboard Performance, Skeleton Loading & Error State",
    date: "May 2026",
    content: whatsNew180,
  },
  {
    version: "1.7.8",
    title: "GPT-5.5, PR Skill CI Gate & Literal Newline Fix",
    date: "May 2026",
    content: whatsNew178,
  },
  {
    version: "1.7.7",
    title: "Per-Epic AI Model Recommendation System",
    date: "April 2026",
    content: whatsNew177,
  },
  {
    version: "1.7.6",
    title: "FogBugz Ticket Grouping & Attachment Fixes",
    date: "April 2026",
    content: whatsNew176,
  },
  {
    version: "1.7.5",
    title: "FogBugz Attachment Proxy Fix",
    date: "April 2026",
    content: whatsNew175,
  },
  {
    version: "1.7.4",
    title: "FogBugz Attachments & Inline Images",
    date: "April 2026",
    content: whatsNew174,
  },
  {
    version: "1.7.3",
    title: "FogBugz Ticket List Pagination",
    date: "April 2026",
    content: whatsNew173,
  },
  {
    version: "1.7.2",
    title: "FogBugz Convert-to-ER Copy Box & Infrastructure Fixes",
    date: "April 2026",
    content: whatsNew172,
  },
  {
    version: "1.7.1",
    title: "FogBugz Web Frontend & AI Provider Configuration",
    date: "April 2026",
    content: whatsNew171,
  },
  {
    version: "1.7.0",
    title: "FogBugz Integration & Dual-Provider Database Safety",
    date: "April 2026",
    content: whatsNew170,
  },
  {
    version: "1.6.8",
    title: "Admin Dashboard Enhancements & CSV Export Sync",
    date: "April 2026",
    content: whatsNew168,
  },
  {
    version: "1.6.7",
    title: "Activity Dashboard KPIs & Cross-Codebase Context",
    date: "April 2026",
    content: whatsNew167,
  },
  {
    version: "1.6.6",
    title: "Admin Activity Dashboard & Epic Append Mode",
    date: "April 2026",
    content: whatsNew166,
  },
  {
    version: "1.6.5",
    title: "Simplified Update Skill",
    date: "April 2026",
    content: whatsNew165,
  },
  {
    version: "1.6.4",
    title: "CLI Registry Discovery & Update Fixes",
    date: "April 2026",
    content: whatsNew164,
  },
  {
    version: "1.6.3",
    title: "MCP Skill Pack Update Fix",
    date: "April 2026",
    content: whatsNew163,
  },
  {
    version: "1.6.2",
    title: "Automated PR Review Cycles & CI/CD Fix",
    date: "April 2026",
    content: whatsNew162,
  },
  {
    version: "1.6.1",
    title: "Mark as Implemented, Unified Compliance Scoring & MCP Fix",
    date: "April 2026",
    content: whatsNew161,
  },
  {
    version: "1.6.0",
    title: "Compliance Validation, Epic State Machine & Pagination Overhaul",
    date: "April 2026",
    content: whatsNew160,
  },
  {
    version: "1.5.0",
    title: "Pagination, SSE Updates, Docs-Audit Tool & CLI Registry Sync",
    date: "April 2026",
    content: whatsNew150,
  },
  {
    version: "1.4.8",
    title: "Release Automation, Skill Pack Seeding & CLI Registry Resolution",
    date: "April 2026",
    content: whatsNew148,
  },
  {
    version: "1.4.7",
    title: "Planner Progress Tracking Fix & Epic Requests UI",
    date: "April 2026",
    content: whatsNew147,
  },
  {
    version: "1.4.6",
    title: "Dashboard Fixes & Planner Agent Improvements",
    date: "March 2026",
    content: whatsNew146,
  },
  {
    version: "1.4.5",
    title: "Dashboard Lifecycle Metrics & Planner Progress Tracking",
    date: "March 2026",
    content: whatsNew145,
  },
  {
    version: "1.4.4",
    title: "Admin Visibility, Lifecycle Sessions & Real-Time Overview",
    date: "March 2026",
    content: whatsNew144,
  },
  {
    version: "1.4.3",
    title: "Real-Time Live Updates & Status Animations",
    date: "March 2026",
    content: whatsNew143,
  },
  {
    version: "1.4.2",
    title: "Skill Pack Cleanup Fix",
    date: "March 2026",
    content: whatsNew142,
  },
  {
    version: "1.4.1",
    title: "MCP Skill Pack Tool Fixes",
    date: "March 2026",
    content: whatsNew141,
  },
  {
    version: "1.4.0",
    title: "Team Epic Requests, SSO-Only Auth & Agent Reorganization",
    date: "March 2026",
    content: whatsNew140,
  },
  {
    version: "1.3.1",
    title: "Feature-Level Execution Monitoring",
    date: "March 2026",
    content: whatsNew131,
  },
  {
    version: "1.3.0",
    title: "SSO, Mobile Redesign & Designer Skill",
    date: "March 2026",
    content: whatsNew130,
  },
  {
    version: "1.2.1",
    title: "Unique Identifiers & Accessibility",
    date: "March 2026",
    content: whatsNew121,
  },
  {
    version: "1.2.0",
    title: "Epic Request Creator Self-Approval",
    date: "March 2026",
    content: whatsNew120,
  },
  {
    version: "1.1.0",
    title: "Sprout Chat — AI-Powered Contextual Help",
    date: "March 2026",
    content: whatsNew110,
  },
  {
    version: "1.0.1",
    title: "Epic Request Status Submenu",
    date: "March 2026",
    content: whatsNew101,
  },
  {
    version: "1.0.0",
    title: "Production Release",
    date: "March 2026",
    content: whatsNew100,
  },
];

export function WhatsNewPage() {
  usePageTitle("What's New");
  
  // Current version from build (e.g., "v1.0.1" -> "1.0.1")
  const currentVersion = APP_VERSION.replace(/^v/, "");
  
  return (
    <div className="pt-4 px-4 md:px-0">
      <div className="glass-card rounded-2xl p-4 md:p-6">
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-1 flex-wrap">
            <h1 className="text-lg font-medium">What's New in CompBox</h1>
            <Badge variant="outline" className="text-xs">{APP_VERSION}</Badge>
          </div>
          <p className="text-muted-foreground text-sm">
            Stay up to date with the latest features and improvements
          </p>
        </div>
        
        <div className="space-y-6">
          {releases.map((release) => (
            <Card key={release.version}>
              <CardHeader className="p-4 md:p-6">
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <div>
                    <CardTitle>Version {release.version}</CardTitle>
                    <CardDescription>{release.title} - {release.date}</CardDescription>
                  </div>
                  {release.version === currentVersion && <Badge>Current</Badge>}
                </div>
              </CardHeader>
              <CardContent className="p-4 md:p-6 pt-0 md:pt-0">
                <MarkdownRenderer content={release.content} />
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
